let heroSlider;
export default () => ({
	id: '',
	autoplay: null,
	loop: null,
	speed: null,
	delay: null,
	disabled_desktop: false,

	createSlider() {
		const slider = document.querySelector(`.hero__slider-${this.id}`);
		const pagination = document.querySelector(`.hero__pagination-${this.id}`);
		const prevButton = document.querySelector(`.hero__prev-slide-${this.id}`);
		const nextButton = document.querySelector(`.hero__next-slide-${this.id}`);
		if (this.disabled_desktop && window.innerWidth >= 1024) return;
		let settings = {};
		if (this.autoplay) {
			settings = {
				slidesPerView: 1,
				loop: this.loop,
				speed: this.speed,
				autoplay: {
					delay: this.delay,
				},
				pagination: {
					el: pagination,
					clickable: true,
				},
				navigation: {
					nextEl: nextButton,
					prevEl: prevButton,
				},
			};
		} else {
			settings = {
				slidesPerView: 1,
				loop: this.loop,
				speed: this.speed,
				pagination: {
					el: pagination,
					clickable: true,
				},
				navigation: {
					nextEl: nextButton,
					prevEl: prevButton,
				},
			};
		}

		new window.Swiper(slider, settings);
	},

	init() {
		this.$watch('autoplay', () => {
			this.createSlider();
		});
	},
});
